import { ELocalStorageKeys } from "constants/enums";

import { localStorageUtil } from "./localStorageUtil";
export const removeUserAuthData = () => {
    const seenTabs = localStorageUtil.getAny(
        ELocalStorageKeys.NEW_MENU_TABS_SEEN
    );

    localStorageUtil.removeAny(ELocalStorageKeys.JWT_TOKEN);
    localStorageUtil.removeAny(ELocalStorageKeys.JWT_TOKEN_TTL);
    localStorageUtil.removeAny(ELocalStorageKeys.USER_DETAILS);
    localStorageUtil.removeAny(ELocalStorageKeys.PERMISSIONS);
    localStorageUtil.removeAny(ELocalStorageKeys.FEATURE_FLAGS);
    localStorageUtil.removeAny(ELocalStorageKeys.PUBLISHER_SOLUTION_MODEL);
    // localStorage.clear();

    if (seenTabs) {
        localStorageUtil.set(ELocalStorageKeys.NEW_MENU_TABS_SEEN, seenTabs);
    }
};